import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import Image from "react-bootstrap/Image";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
// import { SRLWrapper } from "simple-react-lightbox";
import isEmpty from "../../../../store/validation/is-Empty";
import { SuggestionDropDownModelPopup } from "../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/superAdminSuggestionDropDownPopup/SuggestionDropDownModelPopup";
import {
  update_vendor_issues_suggestion,
  get_only_one_issues_suggestions,
} from "../../../../store/actions/VendorIssuesSuggestionActions/VendorIssuesSuggestionActions";

export const LeftIssuesSuggestion = (
  props
  // { props.issuesData, restaurantData, emailData, contactDetails, category }
) => {
  const options = {
    settings: {
      autoplaySpeed: 3000,
      disableKeyboardControls: false,
      disablePanzoom: false,
      disableWheelControls: false,
      hideControlsAfter: 3000,
      lightboxTransitionSpeed: 0.6,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(0, 0, 0, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 200],
      slideTransitionSpeed: 0.6,
      slideTransitionTimingFunction: "linear",
    },
    buttons: {
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
    caption: {
      showCaption: false,
    },
    thumbnails: {
      showThumbnails: false,
    },
    progressBar: {
      showProgressBar: false,
    },
  };

  const data =
    props.issuesData &&
    props.issuesData.restaurant_id &&
    props.issuesData.restaurant_id.contact_detail;

  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const [statusDropDownText, setStatusDropDownText] = useState("");
  const handleStatusChange = (e, type) => {
    e.preventDefault();
    //setOpen(false);
    setStatusDropDownText(type);
  };
  const handleShowStatusList = () => {
    setOpen(true);
  };
  const handleCloseStatusList = () => {
    setStatusDropDownText(props.issuesData && props.issuesData.status);
    setOpen(false);
  };

  const onConfirmClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setStatusDropDownText(props.issuesData && props.issuesData.status);
  }, [props.issuesData && props.issuesData.status]);

  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Awaiting Feedback";
    } else if (status === 3) {
      return "On Hold";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    } else if (status === 6) {
      return "Closed";
    } else if (status === 7) {
      return "Archive";
    } else if (status === 8) {
      return "Called User";
    } else if (status === 9) {
      return "Completed";
    }
  };

  // const onSubmit = (statusDropDownText) => (e) => {
  //   const token = props.token;
  //   let issueId = props.issuesData && props.issuesData._id;
  //   const formData = {};
  //   formData.status = statusDropDownText;
  //   dispatch(
  //     update_vendor_issues_suggestion(
  //       formData,
  //       token,
  //       issueId,
  //       onSuccess(token, issueId, onSuccess)
  //     )
  //   );
  // };

  // const onSuccess = (token, issueId) => (e) => {
  //   dispatch(get_only_one_issues_suggestions(token, issueId));
  //   onConfirmClose();
  // };

  return (
    <React.Fragment>
      <div className="open_issues_view_tickets_left">
        <div className="row">
          <div className="col-2">
            <h5 className="f14-500 text-gray mb-3">Issue ID</h5>
            <h5 className="f12-400">
              {props.issuesData && props.issuesData.issue_id}
            </h5>
          </div>
          <div className="col-3">
            <h5 className="f14-500 text-gray mb-3">Category</h5>
            <h5 className="f12-400">
              {props.issuesData &&
                props.issuesData.category &&
                props.issuesData.category.title}
            </h5>
          </div>
          <div className="col-4">
            <h5 className="f14-500 text-gray mb-3">Issues/Suggestion</h5>
            <h5 className="f12-400">
              {props.issuesData && props.issuesData.type}
            </h5>
          </div>
          <div className="col-3">
            <h5 className="f14-500 text-gray mb-3">Status</h5>
            <div className="mb-2 text-white f9-700 bg-yellow enlblSelect">
              {calcStatus(props.issuesData && props.issuesData.status)}
              {/* <SuggestionDropDownModelPopup
                onOpenModal={handleShowStatusList}
                status={statusDropDownText}
                open={open}
                displayButtonThree={true}
                displayButtonFour={true}
                displayButtonFive={true}
                displayButtonSix={true}
                onCloseModal={handleCloseStatusList}
                buttonTitle="Suggestion Status"
                buttonText="Suggestion Status"
                headerText="Suggestion Status"
                timeTextOne="New"
                timeTextTwo="In-Progress"
                timeTextThree="Awaiting - Feedback"
                timeTextFour="On-Hold"
                timeTextFive="Re-Opened"
                timeTextSix="Resolved"
                timeTextSeven="Closed"
                timeTextEight="Archive"
                timeTextNine="Called User"
                timeTextTen="Completed"
                timeOneClick={(e) => handleStatusChange(e, 0)}
                timeTwoClick={(e) => handleStatusChange(e, 1)}
                timeThreeClick={(e) => handleStatusChange(e, 2)}
                timeFourClick={(e) => handleStatusChange(e, 3)}
                timeFiveClick={(e) => handleStatusChange(e, 4)}
                timeSixClick={(e) => handleStatusChange(e, 5)}
                timeSevenClick={(e) => handleStatusChange(e, 6)}
                timeEightClick={(e) => handleStatusChange(e, 7)}
                timeNineClick={(e) => handleStatusChange(e, 8)}
                timeTenClick={(e) => handleStatusChange(e, 9)}
                onSubmit={onSubmit(statusDropDownText)}
              /> */}
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-6">
            <h5 className="f14-500 text-gray mb-3">Issue Date/Time</h5>
            <h5 className="f12-400">
              {moment(props.issuesData && props.issuesData.createdAt).format(
                "Do MMMM YYYY, hh:mm A"
              )}
            </h5>
          </div>
          <div className="col-6">
            <h5 className="f14-500 text-gray mb-3">Issue Title</h5>
            <h5 className="f12-400">
              {props.issuesData && props.issuesData.issue_title}
            </h5>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <h5 className="f14-500 text-gray mb-3">Description</h5>
          </div>
          <div className="col-8">
            <h5 className="f12-400">
              {props.issuesData && props.issuesData.comment}
            </h5>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <h5 className="f12-500 text-gray mb-3">Photos</h5>
          </div>
          <div className="col-12">
            <div className="d-flex flex-wrap align-items-center">
              {props.issuesData &&
                props.issuesData.attachment &&
                props.issuesData.attachment.map((photos, index) => {
                  return (
                    <React.Fragment key={index}>
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <div className="enIMG33 rounded-circle mr-2">
                            <Image
                              fluid
                              src={photos}
                              alt="Icon"
                              title="Issues Photo"
                            />
                          </div>
                        </SRLWrapper>
                      </SimpleReactLightbox>
                      {/* <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <Image
                            fluid
                            alt="Restaurant Photo"
                            title="Restaurant Photo"
                            className="w-25 rounded-circle"
                            src={photos}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox> */}
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
        </div>
        <hr />
        {/* <div className="row">
          <div className="col-4 text-center">
            <h5 className="f14-500 mb-2">Restaurant Name</h5>
            <SimpleReactLightbox>
              <SRLWrapper options={options}>
                <Image
                  fluid
                  alt="Restaurant Photo"
                  title="Restaurant Photo"
                  className="w-25 rounded-circle"
                  src={
                    props.issuesData &&
                    props.issuesData.restaurant_id &&
                    props.issuesData.restaurant_id.logo_url
                  }
                />
              </SRLWrapper>
            </SimpleReactLightbox>
            <h5 className="f16-500 mt-2 mb-2">
              {props.issuesData &&
                props.issuesData.restaurant_id &&
                props.issuesData.restaurant_id.restaurant_name}
            </h5>
          </div>
          <div className="col-4">
            <h5 className="f14-500 mb-2">Address</h5>
            <h5 className="f12-400 mb-2">
              {props.issuesData &&
                props.issuesData.restaurant_id &&
                props.issuesData.restaurant_id.restaurant_address}
            </h5>
          </div>
          <div className="col-4">
            <h5 className="f14-500 mb-2">Restaurant Number</h5>
            {data &&
              data.map((number, index) => {
                return (
                  <React.Fragment key={index}>
                    <h5 className="f12-400 mb-2">
                      {number.country_code + "-" + number.mobile_no}
                    </h5>
                  </React.Fragment>
                );
              })}
            <h5 className="f14-500 mb-2 mt-3">City</h5>
            <h5 className="f12-400 mb-2">
              {props.issuesData &&
                props.issuesData.restaurant_id &&
                props.issuesData.restaurant_id.city}
            </h5>
          </div>
        </div> */}
      </div>
    </React.Fragment>
  );
};
